<template>
  <div class="page">
    <z-header></z-header>
    <div class="min_width">
      <div class="success_box">
        <img src="../../assets/ic_success.png" />
        <span>支付成功</span>
      </div>
    </div>
    <z-footer></z-footer>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.success_box {
  height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  >span{
      margin-top: 24px;
      color: #333333;
      font-size: 18px;
      font-weight: bold;
  }
}
</style>
